import { render } from "./list.vue?vue&type=template&id=f4412406&scoped=true&ts=true"
import script from "./list.vue?vue&type=script&lang=tsx"
export * from "./list.vue?vue&type=script&lang=tsx"

import "./list.vue?vue&type=style&index=0&id=f4412406&lang=scss&scoped=true"

import exportComponent from "/workspace/ops/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4412406"]])

export default __exports__